// extracted by mini-css-extract-plugin
export default {"component-wrapper":"LeftSide_component-wrapper__QxdUu","animation":"LeftSide_animation__MIl7U","text":"LeftSide_text__4dsbC"};